import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';
import ConfirmationBranchListPopup from 'Components/ConfirmationBranchListPopUp';
import Checkbox from 'Components/Checkbox';
import {ReactComponent as DownArrow} from 'Icons/downArrow.svg';
import {ReactComponent as EditIcon} from 'Icons/edit.svg';
import {ReactComponent as CancelIcon} from 'Icons/cancel.svg';
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import SwitchBox  from "Components/Switch/SwitchBox";
import { isAdaniWilmar } from 'Utils/';
import { DEEPAK_PHENOLICS, RAJPETRO } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

class GroupContainer extends Component {
    constructor(props) {
        super(props);
        const grpId = props.group.id;
        this.state = {
            isTransportersShown : true,
            groupName: {
                [grpId]: props.group.name,
            },
            selectedOption: null,
            selectedOptionList:[],
            isBranchPopupShown:false
        }
    }
    toggleTransporters = ()=> {
        this.setState({
            isTransportersShown: !this.state.isTransportersShown
        });
    }

    onChange=(e)=> {
        this.setState({
            [e.target.name]: e.target.value,
            selectedOption:null
        })
    }

    handleBranchSelection = (selectedOption) => {
            this.setState({
                selectedOption ,
                selectedOptionList:[]
            });
    }

    showBranchPopup = ()=>{
        const { group , branchesList, providerType }  = this.props;
        let { selectedOption } = this.state;
        if( group && selectedOption && selectedOption.length > 0 && Object.keys(group).length > 0 && group.branch_Id ){
        selectedOption = branchesList.filter(branch =>{
            return group.branch_Id.indexOf(branch.value) > -1;
        })

         }else{
         this.setState({
            branchesList
         })
         }

         if(group && branchesList && branchesList.length > 0 && Object.keys(group).length > 0 && group.branch_Id){
            selectedOption = branchesList.filter(branch =>{
                return group.branch_Id.indexOf(branch.value) > -1;
            })
         }
        this.setState({
            isBranchPopupShown: providerType === 24 ? false : true,
            selectedOption
        })
       }
       cancelPopUp=()=>{
        // const { group , branchesList }  = this.props;
        //let { selectedOption , selectedOptionList} = this.state;
        // if(selectedOption && selectedOption.length>0 && group.branch_Id!==null){
        // selectedOption = branchesList.filter(branch =>{
        //     return group.branch_Id.indexOf(branch.value) > -1;
        // })
        
        // selectedOptionList=[];
        // selectedOption.forEach((item) => {
        //    selectedOptionList.push(item.value);
        //  });
        //  this.props.branchModified(selectedOptionList);
        // }
        this.setState({
            isBranchPopupShown: false,
            selectedOptionList: []
        });
        
    }

    confirmPopUp=()=>{
        let { selectedOption , selectedOptionList} = this.state;
        this.setState({
            selectedOptionList:[]
        });
        if(selectedOption && selectedOption.length>0){
        selectedOption.forEach((item) => {
            selectedOptionList.push(item.value);
          });
        }
        this.props.branchModified(selectedOptionList);
        this.setState({
            isBranchPopupShown:false,
        });
    }
    onGroupNameChange = (e) => {
        const { group } = this.props;
        const { groupName } = this.state;
        groupName[group.id] = e.target.value
        this.setState({
            groupName 
        }, () => {
            this.props.nameModified(this.state.groupName[group.id]);
        });
    }
    // addTransporterToGroup = () => {
    //     if (this.props.group) {
    //         this.props.editTransporterGroup(this.props.group.id);
    //     }
    // }
    handleRemoveTransporter = (transporter) => {
        this.props.removeTransporterFromGroup(transporter.id);
    }

    handleChangeActive =(groupId, transporterId, status)=>{
    this.props.activeOrdeactivatedTransporter(groupId, transporterId, status);
    }

    render() {
        const { group, selectedList, selectedTransporters, editingGroup ,  branchesList, viewMode, providerType} = this.props;
        const inEditMode =  group.id && editingGroup ? (group.id === editingGroup) : false;
        return (
            <>
            {(viewMode ? true : (group.transporters || []).filter(trans => trans.is_active).length > 0) && <div>
                <div className={ClassNames("flex flex-middle flex-between mt-20 pMainText", {
                    
                })}>
                    <DownArrow onClick={this.toggleTransporters} className={ClassNames("pa", {
                        'rotate-180': this.state.isTransportersShown,
                        'rotate-0': !this.state.isTransportersShown
                    })}/>
                    {!selectedList && <input type='checkbox' className='ml-20' onClick={this.props.toggleAllTransporters} disabled={this.props.autoSelectTransporters} checked={selectedTransporters.length === group.transporters.filter(trans => trans.is_active).length}/>}
                    <div className="pl-20 flex-1 row-100 flex flex-middle pr-15">
                        {
                           
                            <div className="wt-80p curP" onClick={this.toggleTransporters}>{group.name}</div> 
                        }
                    </div>
                </div>
                <div className={ClassNames("bg-white height-transition br-5 pl-40 border-bottom-light", {
                    'disabled curNA': this.props.autoSelectTransporters
                })}
                style={{
                    overflowY: 'hidden',
                    height: 30*(viewMode ? group.transporters.length : group.transporters.filter(trans => trans.is_active).length)*(this.state.isTransportersShown?1:0)
                }}
                >
                    {
                        group.transporters.map((transporter, index)=> {
                            return (
                                <>
                                {(viewMode ? true : transporter.is_active) && <div key={index} className="flex ht-30 flex-middle ptext">
                                {!selectedList && <input type='checkbox' id={"group-transporter" + group.id + transporter.id} onClick={()=> {
                                        this.props.toggleTransporter(transporter);
                                    }}
                                    checked={selectedTransporters.indexOf(transporter.id) > -1}
                                    />}
                                { viewMode && 
                                    <SwitchBox transporter={transporter} groupId={group.id} handleChangeActive={this.handleChangeActive}></SwitchBox>}
                                    <label className="wt-87p pl-10" htmlFor={"group-transporter" + group.id + transporter.id}>
                                        {transporter.name}
                                    </label>
                                    {
                                        inEditMode && 
                                        <span className="wt-20 ht-20 wt-10p" onClick={() => this.handleRemoveTransporter(transporter)}>
                                            <DeleteIcon className="wt-20 ht-20 tRight curP" />
                                        </span>
                                    }
                                </div>}
                                </>
                            )
                        })
                    }
                </div>
                {
                    // inEditMode && <button className="ht-30 br-20 theme-color border-theme fs-16 fBold pl-20 pr-20 mr-20" onClick={this.addTransporterToGroup}>Add</button>
                }
            </div>}
            </>
        )
    }
}

export default GroupContainer;
